import axios from "axios";
import {
  interceptor,
  GET_MONTHLY_SALES_PROMOTION_CONTRACTS_INFO,
  GET_YEARLY_SALES_PROMOTION_CONTRACTS_INFO,
} from ".";
import store from "../store";
// import { BASE_URL } from "../utils/helper";

interceptor(axios, store);
export function getMonthlySalesPromotionInfo(start_date){
  return {
    type: GET_MONTHLY_SALES_PROMOTION_CONTRACTS_INFO,
    payload: axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/core/sales_dashboard/adminSalesInfo/monthly/contractInfo/${start_date}`,    
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      }
    )
  };
}

export function getYearlySalesPromotionInfo(type,start_date){
  return {
    type: GET_YEARLY_SALES_PROMOTION_CONTRACTS_INFO,
    payload: axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/core/sales_dashboard/adminSalesInfo/yearly/contractInfo/${type}/${start_date}`,    
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      }
    )
  };
}

